import { IndexedDBConfig } from '@softline/core';

export const SOFTLINE_CONFIG_PMS_STEMPELTERMINAL_INDEXED_DB_STORE: IndexedDBConfig = {
  version: 1,
  name: 'stempel-terminal',
  objectStoreConfigs: [
    {
      name: 'offline-stempel',
      parameters: { keyPath: 'time', autoIncrement: false, persistent: true },
      schema: []
    }
  ]
};
